import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons/faCaretRight";
import { faSquare } from "@fortawesome/free-regular-svg-icons/faSquare";
import * as R from "ramda";

const estilosPesquisaClasse = require("./pesquisaClasse.module.scss").default;

export type DadosClasseProduto = {
  Atualizado: string;
  ClasseProduto: string;
  Codigo?: any;
  Descricao: string;
  Hierarquia: string;
  Nivel: number;
  Nome: string;
  Analitico?: any;
  SaiNaLista?: any;
  Ativa?: any;
  Similaridade?: any;
  PagaComissaoIndicadorOferta?: any;
  DescricaoDetalhada?: any;
  Filhos?: DadosClasseProduto[];
  Id: number;
  UserMessage?: any;
  Transforming: boolean;
};

export type PesquisaClasseProps = {
  classesProdutos: any;
  onClasseSelecionada: (codigo: string) => void;
};

export const PesquisaClasse = (props: PesquisaClasseProps) => {
  const [classesExpandidas, setClassesExpandidas] = useState<string[]>([]);

  const toggleClassesExpandias = (codigo: string) => {
    if (classesExpandidas.includes(codigo)) {
      setClassesExpandidas(R.filter((c) => c != codigo, classesExpandidas));
    } else {
      setClassesExpandidas(classesExpandidas.concat(codigo));
    }
  };

  const renderizaHierarquia = (lista: any) => {
    return lista?.length > 0 ? (
      <ul className={estilosPesquisaClasse.hierarquia}
        id="PesquisaClasse-ul"
      >
        {lista.map((item) => (
          <li 
            key={item.ClasseProduto}
            id={`PesquisaClasse-li-${item.ClasseProduto}`}
          >
            <a
              id={`PesquisaClasse-link-${item.ClasseProduto}`}
              onClick={(e) => {
                toggleClassesExpandias(item.ClasseProduto);
                e.preventDefault();
              }}
              href="#"
            >
              <FontAwesomeIcon
                className={estilosPesquisaClasse.icon}
                id={`PesquisaClasse-FontAwesomeIcon-${item.ClasseProduto}`}
                icon={
                  item.Filhos?.length == null
                    ? faSquare
                    : classesExpandidas.includes(item.ClasseProduto)
                      ? faCaretDown
                      : faCaretRight
                }
              />
            </a>
            <a
              id={`PesquisaClasse-link2-${item.ClasseProduto}`}
              onClick={(e) => {
                props.onClasseSelecionada(item.ClasseProduto);
                e.preventDefault();
              }}
              href="#"
            >
              {item.Nome}
            </a>
            {item.Filhos?.length > 0 &&
              classesExpandidas.includes(item.ClasseProduto)
              ? renderizaHierarquia(item.Filhos)
              : ""}
          </li>
        ))}
      </ul>
    ) : (
      <></>
    );
  };

  return <>{renderizaHierarquia(props.classesProdutos)}</>;
};
